const Routes = [
  {
    path: '/product-master',
    name: 'ProductMaster',
    component: () => import('@/app/product_master/TheProductMaster'),
    redirect: '/product-master/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/product_master/views/Index')
      },
      {
        path: 'legacy',
        name: 'materialManagementLegacy',
        component: () => import('@/app/admin/views/MaterialManagementLegacy')
      },
      {
        path: 'create',
        name: 'createProducts',
        component: () => import('@/app/admin/views/CreateProducts')
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/product_master/Routes.js